import type { TFunction } from "i18next";

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

/**
 * Compact "time ago" label: "40s ago", "37m ago", "4h ago", "2 days ago",
 * "1 week ago". Returns null from two weeks on, so the caller can show the
 * date instead.
 */
export const shortTimeAgo = (
  date: Date,
  t: TFunction,
  now: Date = new Date()
): string | null => {
  const seconds = Math.max(
    0,
    Math.floor((now.getTime() - date.getTime()) / 1000)
  );
  if (seconds < MINUTE)
    return t("common.timeAgo.seconds", "{{count}}s ago", { count: seconds });
  if (seconds < HOUR)
    return t("common.timeAgo.minutes", "{{count}}m ago", {
      count: Math.floor(seconds / MINUTE),
    });
  if (seconds < DAY)
    return t("common.timeAgo.hours", "{{count}}h ago", {
      count: Math.floor(seconds / HOUR),
    });
  if (seconds < WEEK)
    return t("common.timeAgo.days", "{{count}} days ago", {
      count: Math.floor(seconds / DAY),
    });
  if (seconds < 2 * WEEK) return t("common.timeAgo.week", "1 week ago");
  return null;
};
